import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

interface Book {
  id: string;
  title: string;
  author: string;
  cover: string;
  coverAlt: string;
  rating: number;
  genre: string;
  reviewDate: string;
  reviewExcerpt: string;
}

const recentBooks: Book[] = [
{
  id: 'book_1',
  title: 'The Midnight Library',
  author: 'Matt Haig',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b87a6d05-1766775987298.png",
  coverAlt: 'The Midnight Library book cover showing dark blue background with golden library illustration',
  rating: 4.5,
  genre: 'Fiction',
  reviewDate: '2026-01-28',
  reviewExcerpt: 'A profound exploration of life choices and infinite possibilities...'
},
{
  id: 'book_2',
  title: 'Project Hail Mary',
  author: 'Andy Weir',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1b8589ffb-1765370251985.png",
  coverAlt: 'Project Hail Mary book cover with space and rocket imagery on dark background',
  rating: 5.0,
  genre: 'Science Fiction',
  reviewDate: '2026-01-25',
  reviewExcerpt: 'Weir delivers another masterpiece of hard science fiction with heart...'
},
{
  id: 'book_3',
  title: 'The Seven Husbands of Evelyn Hugo',
  author: 'Taylor Jenkins Reid',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1f2d2c4a5-1765370248901.png",
  coverAlt: 'The Seven Husbands of Evelyn Hugo book cover with elegant vintage Hollywood aesthetic',
  rating: 4.8,
  genre: 'Historical Fiction',
  reviewDate: '2026-01-22',
  reviewExcerpt: 'A captivating tale of love, ambition, and Hollywood glamour...'
},
{
  id: 'book_4',
  title: 'Atomic Habits',
  author: 'James Clear',
  cover: "https://images.unsplash.com/photo-1716171848317-1ca95b7f99ef",
  coverAlt: 'Atomic Habits book cover with minimalist design and bold typography',
  rating: 4.7,
  genre: 'Self-Help',
  reviewDate: '2026-01-20',
  reviewExcerpt: 'A practical guide to building good habits and breaking bad ones...'
},
{
  id: 'book_5',
  title: 'The Silent Patient',
  author: 'Alex Michaelides',
  cover: "https://images.unsplash.com/photo-1709671704815-29c6dccb0adc",
  coverAlt: 'The Silent Patient book cover with mysterious woman silhouette on dark background',
  rating: 4.3,
  genre: 'Thriller',
  reviewDate: '2026-01-18',
  reviewExcerpt: 'A psychological thriller that keeps you guessing until the very end...'
},
{
  id: 'book_6',
  title: 'Educated',
  author: 'Tara Westover',
  cover: "https://img.rocket.new/generatedImages/rocket_gen_img_1a67dd3db-1766575716473.png",
  coverAlt: 'Educated memoir book cover with mountain landscape and graduation cap imagery',
  rating: 4.9,
  genre: 'Memoir',
  reviewDate: '2026-01-15',
  reviewExcerpt: 'A powerful memoir about education, family, and self-discovery...'
}];


export default function RecentReviews() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-12">
          <div>
            <h2 className="text-4xl md:text-5xl font-serif font-semibold text-foreground mb-4 tracking-tight">
              Recently Reviewed
            </h2>
            <p className="text-muted-foreground font-light max-w-2xl">
              Fresh perspectives on the latest books I've explored
            </p>
          </div>
          <Link
            href="/book-reviews"
            className="inline-flex items-center gap-2 text-sm text-primary hover:text-primary/80 transition-colors border-b border-primary pb-1">

            View all reviews
            <Icon name="ArrowRightIcon" size={16} />
          </Link>
        </div>

        {/* Books Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {recentBooks.map((book) =>
          <Link
            key={book.id}
            href="/book-reviews"
            className="group cursor-pointer">

              <div className="glass-card rounded-xl overflow-hidden hover:bg-card/80 transition-all duration-300">
                {/* Book Cover */}
                <div className="relative h-64 overflow-hidden bg-muted">
                  <AppImage
                  src={book.cover}
                  alt={book.coverAlt}
                  className="w-full h-full object-cover image-hover-zoom grayscale group-hover:grayscale-0 transition-all duration-700" />

                  <div className="absolute top-4 right-4 flex items-center gap-1 px-3 py-1.5 rounded-full bg-background/80 backdrop-blur-sm">
                    <Icon name="StarIcon" size={14} className="text-accent" />
                    <span className="text-sm font-semibold text-foreground">{book.rating}</span>
                  </div>
                </div>

                {/* Book Info */}
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="text-xs uppercase tracking-widest text-primary font-semibold">
                      {book.genre}
                    </span>
                    <span className="text-xs text-muted-foreground">•</span>
                    <span className="text-xs text-muted-foreground">
                      {new Date(book.reviewDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
                    </span>
                  </div>

                  <h3 className="text-xl font-serif font-semibold text-foreground mb-2 group-hover:text-primary transition-colors line-clamp-2">
                    {book.title}
                  </h3>

                  <p className="text-sm text-muted-foreground mb-4">
                    by {book.author}
                  </p>

                  <p className="text-sm text-foreground/80 line-clamp-2 leading-relaxed">
                    {book.reviewExcerpt}
                  </p>
                </div>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>);

}